import { Injectable, EventEmitter, Output, Directive } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IUser, AUTH_QUERY_LOGIN, IAuthentication, ContactExistsDetailsQuery, IContactExists } from '@ebb-v2/ebb-integration';
import { Apollo } from 'apollo-angular';
import { LocationStrategy } from '@angular/common';
import { environment } from '../../environments/environment';

export const HOMEOWNER_TYPE = 'HOMEOWNER';
export const CONTRACTOR_TYPE = 'CONTRACTOR';
export const ENGINEER_TYPE = 'ENGINEER';
export const INSPECTOR_TYPE = 'INSPECTOR';

@Directive()
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    @Output() getCurrentUserName: EventEmitter<any> = new EventEmitter();
    @Output() getCurrentUser: EventEmitter<any> = new EventEmitter();
 
    private uriApi: string;
    private uriSpaRedirectAuthorization: string;
    private programTypeCodeOptionSet: string;
    private isProgramCeaBb: boolean;
    private _isProgramEss: boolean;
    private _isProgramEbb: boolean;
    private spaBaseUrl: string;
    private uriSpaRedirectLogin: string;
    private uriSpaRegistration: string;
    private currentUserSubject: BehaviorSubject<IUser>;

    public currentUser: Observable<IUser>;
    public redirectUrl: string;


    constructor(
      private locationStrategy: LocationStrategy,
      private apollo: Apollo    ) {
        if (window['ebbApi']) { //set by hosted site
          this.uriApi = window['ebbApi'];
          this.uriSpaRegistration = '/files/registration/register/questionnaire'; //link to reg spa
        } else {
          this.uriApi = `https://${environment.devBaseUrl}/api`;
          this.uriSpaRedirectAuthorization = 'http://localhost:4577/authorization';
          this.uriSpaRedirectLogin = 'http://localhost:4577/login';
          this.uriSpaRegistration = 'http://localhost:4200/register/questionnaire';
        }
        
        if(window['spaBaseUrl']) {
          this.spaBaseUrl = window['spaBaseUrl'];
        } else {
          const baseurl = window.location.origin;
          this.spaBaseUrl = `${baseurl}${this.locationStrategy.getBaseHref()}`;
        }

        this.uriSpaRedirectAuthorization =  `${this.spaBaseUrl}/authorization`;
        this.uriSpaRedirectLogin = `${this.spaBaseUrl}/login`;

        //program used for B2C policy selection
        const programLocalStore = localStorage.getItem('ebbprogram');
        if (window['program']) {
          this.programTypeCodeOptionSet = window['program'];
        } else if (programLocalStore) {
          this.programTypeCodeOptionSet = programLocalStore;
        } else {
          this.programTypeCodeOptionSet = 'FEMA|EBB'; //default to EBB programs
        }
        const programsSplit = this.programTypeCodeOptionSet.split('|');
        this.isProgramCeaBb = programsSplit.filter(program => program === 'CEA BB').length >= 1;
        this._isProgramEss = programsSplit.filter(program => program === 'ESS').length >= 1;
        this._isProgramEbb = !(this.isProgramCeaBb || this._isProgramEss);
     
        //set current user
        this.currentUserSubject = new BehaviorSubject<IUser>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
        
    }

    public get uriSpaRegister(): string {
        return this.uriSpaRegistration;
    }

    public get programType(): string {
      return this.programTypeCodeOptionSet;
    }

    public isProgramCea() : boolean {
      return this.isProgramCeaBb;
    }

    public isProgramEss(): boolean {
      return this._isProgramEss;
    }

    public isProgramEbb(): boolean {
      return this._isProgramEbb;
    }

    public get currentUserValue(): IUser {
      return this.currentUserSubject.value;
    }
    public get trainingType(): string {

      let training = localStorage.getItem('training');
      if (window['training']) {
        training = window['training'];
      }  else {
        training='700000000'; //default to EBB programs
      }
      return training;
    }
    public setCurrentUserValue(user: IUser) {
        if (user) {
            localStorage.setItem('dashboard', user.mode);
            this.currentUserSubject.next(user);
            this.getCurrentUserName.emit(user.fullName);
            this.getCurrentUser.emit(user);
        }else{
          localStorage.setItem('dashboard', '');
            this.currentUserSubject.next(null);
            this.getCurrentUserName.emit(null);
            this.getCurrentUser.emit(null);

        }
    }

    public isMultiUser(user: IUser)  {
      if(user)  {
        if(user.isContractor && user.isHomeowner)  {
          return true;
        }
      }

      return false;
    }

    public defaultUserMode(user: IUser)  {
      if (this.isMultiUser(user)) {
        const dashboard = localStorage.getItem('dashboard');
        return (dashboard === CONTRACTOR_TYPE || dashboard == HOMEOWNER_TYPE) ? dashboard : HOMEOWNER_TYPE;
      }

      if(user.isHomeowner === true)  {
        return HOMEOWNER_TYPE;
      }

      if(user.isContractor === true)  {
        return CONTRACTOR_TYPE;
      }

      if(user.isEngineer === true)  {
        return ENGINEER_TYPE;
      }

      if(user.isInspector === true)  {
        return INSPECTOR_TYPE;
      }

      return '';
    }

   

    public isContractor(user: IUser)  {
      if(user == null){
        return false;
      }
      return  user && user.isContractor === true && user.mode === CONTRACTOR_TYPE;
    }

   



  

  
   

    public getCurrentAuthentication() : Observable<IAuthentication> {
        return this.apollo.query({
            query: AUTH_QUERY_LOGIN
          })
          .pipe(map(result => result.data['authentication'] as IAuthentication));
    }

    public getUserStatus(email: string) : Observable<IContactExists>{
        return this.apollo.query({
            query: ContactExistsDetailsQuery,
            fetchPolicy: 'network-only',
            variables: { email: email}
          })
          .pipe(map(result => {
            if(result.data['message']) {
              return result.data['message'];
            }
            return result.data['contactExistsDetail'] as IContactExists;
          }
        ));
    }

   
}
